import { render, staticRenderFns } from "./DeleteDatasetWithResources.vue?vue&type=template&id=45813ba2&scoped=true"
import script from "./DeleteDatasetWithResources.vue?vue&type=script&lang=js"
export * from "./DeleteDatasetWithResources.vue?vue&type=script&lang=js"
import style0 from "./DeleteDatasetWithResources.vue?vue&type=style&index=0&id=45813ba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45813ba2",
  null
  
)

export default component.exports